import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { v4 } from 'uuid';
import Chip, { ChipColors } from '@prism/chip';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var _excluded$2 = ["checked", "className", "disabled", "id", "indeterminate", "innerRef", "label", "name", "onChange", "readonly", "value"];

var Checkbox = function Checkbox(props) {
  var checked = props.checked,
      className = props.className,
      disabled = props.disabled,
      id = props.id,
      indeterminate = props.indeterminate,
      innerRef = props.innerRef,
      label = props.label,
      name = props.name,
      onChange = props.onChange;
      props.readonly;
      var value = props.value,
      attributes = _objectWithoutProperties(props, _excluded$2);

  var computedClassName = classNames(className, indeterminate && 'checkbox-indeterminate');

  var handleOnChange = function handleOnChange(e) {
    if (onChange) {
      var targetObj = {
        id: id,
        checked: checked,
        disabled: disabled,
        label: label,
        name: name,
        value: value,
        indeterminate: indeterminate
      };
      onChange(_objectSpread2(_objectSpread2({}, e), {}, {
        targetObj: targetObj
      }));
    }
  };

  var uid = v4();
  return /*#__PURE__*/React.createElement("div", {
    className: "checkbox--custom"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: name,
    className: "itemCol itemContent checkbox-label"
  }, /*#__PURE__*/React.createElement("input", _extends({
    id: id || uid,
    name: name,
    type: "checkbox",
    className: computedClassName,
    defaultChecked: checked,
    disabled: disabled,
    value: value,
    indeterminate: indeterminate,
    ref: innerRef,
    onChange: handleOnChange
  }, attributes)), /*#__PURE__*/React.createElement("span", {
    className: "checkbox-label"
  }, label)));
};

Checkbox.propTypes = {
  checked: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  indeterminate: PropTypes.bool,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.func]),
  label: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  readonly: PropTypes.bool,
  value: PropTypes.string
};
Checkbox.defaultProps = {
  checked: false,
  className: undefined,
  disabled: false,
  id: null,
  indeterminate: undefined,
  innerRef: null,
  label: undefined,
  name: undefined,
  onChange: function onChange() {},
  readonly: false,
  value: undefined
};

var _excluded$1 = ["checked", "className", "id", "indeterminate", "innerRef", "label", "onChange"];

var ControlledCheckbox = function ControlledCheckbox(props) {
  var checked = props.checked,
      className = props.className,
      id = props.id,
      indeterminate = props.indeterminate,
      innerRef = props.innerRef,
      label = props.label,
      onChange = props.onChange,
      attributes = _objectWithoutProperties(props, _excluded$1);

  var _useState = useState(checked),
      _useState2 = _slicedToArray(_useState, 2),
      isChecked = _useState2[0],
      setIsChecked = _useState2[1];

  useEffect(function () {
    setIsChecked(checked);
  }, [checked]);

  var handleOnChange = function handleOnChange(e) {
    setIsChecked(!isChecked);
    onChange(e);
  };

  var computedClassName = classNames(className, indeterminate && 'checkbox-indeterminate');
  return /*#__PURE__*/React.createElement("div", {
    className: "checkbox--custom"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    className: "itemCol itemContent checkbox-label"
  }, /*#__PURE__*/React.createElement("input", _extends({
    id: id,
    type: "checkbox",
    className: computedClassName,
    checked: isChecked,
    indeterminate: indeterminate,
    onChange: handleOnChange,
    ref: innerRef
  }, attributes)), /*#__PURE__*/React.createElement("span", {
    className: "checkbox-label"
  }, label)));
};

ControlledCheckbox.propTypes = {
  checked: PropTypes.bool,
  className: PropTypes.string,
  id: PropTypes.string,
  indeterminate: PropTypes.bool,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.func]),
  label: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.func]),
  onChange: PropTypes.func
};
ControlledCheckbox.defaultProps = {
  checked: false,
  className: undefined,
  id: v4(),
  indeterminate: false,
  innerRef: null,
  label: null,
  onChange: function onChange() {}
};

var _excluded = ["disabled", "label", "name"];

var CheckboxList = function CheckboxList(props) {
  var chipColor = props.chipColor,
      data = props.data,
      disabled = props.disabled,
      onChange = props.onChange;
  return /*#__PURE__*/React.createElement("div", {
    className: "check-list"
  }, data.map(function (item) {
    var itemDisabled = item.disabled;
        item.label;
        item.name;
        var attributes = _objectWithoutProperties(item, _excluded);

    return /*#__PURE__*/React.createElement("div", {
      key: v4(),
      className: "check-list__item"
    }, /*#__PURE__*/React.createElement(Checkbox, _extends({
      disabled: disabled || itemDisabled,
      name: item.name || item.label || '',
      label: item.label || item.name || '',
      onChange: onChange,
      className: "check-list__item"
    }, attributes)), item.count && item.count > 0 && /*#__PURE__*/React.createElement(Chip, {
      color: chipColor,
      className: "filter-count"
    }, item.count));
  }));
};

CheckboxList.propTypes = {
  chipColor: PropTypes.oneOf(ChipColors),
  data: PropTypes.oneOfType([PropTypes.array]),
  disabled: PropTypes.bool,
  onChange: PropTypes.func
};
CheckboxList.defaultProps = {
  chipColor: 'medium',
  data: [],
  disabled: false,
  onChange: function onChange() {}
};

Checkbox.List = CheckboxList;
Checkbox.Controlled = ControlledCheckbox;

export { CheckboxList, ControlledCheckbox, Checkbox as default };
//# sourceMappingURL=index.js.map
